module.exports = __webpack_public_path__ + "img/ardi-logo.7499744c.svg";